/** 비정형 studentAnswer(unknown)를 QuizRenderer 가 받는 string[]로 정규화. */
export function toAnswerArray(value: unknown): string[] {
  if (value === null || value === undefined) return []
  if (Array.isArray(value)) {
    return value.map((v) => (typeof v === 'string' ? v : JSON.stringify(v)))
  }
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return [String(value)]
  }
  return [JSON.stringify(value)]
}

/** lc_test_item.answer(JSON 문자열)와 일반 문자열 답안을 화면용 값으로 복원한다. */
export function parseStoredAnswer(raw: string | null | undefined): unknown {
  if (!raw) return undefined
  const trimmed = raw.trim()
  if (!trimmed) return undefined
  if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
    try {
      return JSON.parse(trimmed)
    } catch {
      return raw
    }
  }
  return raw
}

/** 빈 문자열/빈 배열은 미제출로, 하나라도 실제 값이 있으면 제출 답안으로 본다. */
export function hasSubmittedAnswer(value: unknown): boolean {
  if (value === null || value === undefined) return false
  if (Array.isArray(value)) return value.some(hasSubmittedAnswer)
  if (typeof value === 'string') return value.trim().length > 0
  if (typeof value === 'number' || typeof value === 'boolean') return true
  if (typeof value === 'object') return Object.keys(value).length > 0
  return false
}
